<template>
  <div class="bto-sb-widget bto-sb-widget-quick-links bto-sb-widget-quick-links-horizontal">
    <div class="bto-sb-widget-content">
      <div class="bto-sb-scrolling-menu">
        <ul>
          <li v-for="(item, idx) in links" :key="idx">
            <span class="bto-sb-quick-links-icon" v-if="item.imgUrl">
              <img :src="`${item.imgUrl}`" :alt="item.label" />
            </span>
            <span class="bto-sb-quick-links-item">
              <component :is="item.component" v-bind="item.props">{{ item.label }}</component>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import { getLinkProps, getQuickLinks, quickLinksStore } from '@bto-services/quick-links';

  export default {
    name: 'QuickLinksHorizontalWidget',
    props: {
      quickLinks: {
        fieldType: 'link-repeater',
        label: 'Add Link',
        hasIcons: true,
        default: () => [
          {
            applied: true,
            editmode: false,
            iconUrl: '',
            label: '',
            link: '#',
            target: '_self',
          },
        ],
      },
      getLinksFromSB: {
        type: Boolean,
        default: false,
        label: 'Get links from SB',
        description: 'Flag to get quick links from SB Admin',
      },
    },
    computed: {
      links() {
        if (this.getLinksFromSB) {
          return quickLinksStore.value.links;
        }
        return this.quickLinks.map(ql => getLinkProps(ql));
      },
    },
    created() {
      if (this.getLinksFromSB) {
        getQuickLinks();
      }
    },
  };
</script>
